import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { GetNtxSettingsList } from '../../store/NTX/Settings/settingsSlice';

const useGetNtxSettings = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (SettingsLiat?.length === 0) {
      dispatch(GetNtxSettingsList());
    }
  }, []);
  const { SettingsLiat, loading, error } = useAppSelector(state => state.NtxSettings);

  var HRSettingList = SettingsLiat?.filter(f => f.moduleId === '0a6c6b89-1d52-4eaa-8d2c-010c74b1f6e0');

  var AMESettingList = SettingsLiat?.filter(f => f.moduleId === '0a6c6b89-1d52-4eaa-8d2c-020c74b1f6e0');

  var SUSettingList = SettingsLiat?.filter(f => f.moduleId === '0a6c6b89-1d52-4eaa-8d2c-030c74b1f6e0');

  var FLEETSettingList = SettingsLiat?.filter(f => f.moduleId === '0a6c6b89-1d52-4eaa-8d2c-040c74b1f6e0');

  var NTXSettingList = SettingsLiat?.filter(f => f.moduleId === '0a6c6b89-1d52-4eaa-8d2c-000c74b1f6e0');

  var FinanceSettingList = SettingsLiat?.filter(f => f.moduleId === '0a6c6b89-1d52-4eaa-8d2c-050c74b1f6e0');

  var ReportsSettingList = SettingsLiat?.filter(f => f.moduleId === '0a6c6b89-1d52-4eaa-8d2c-001c74b1f6e0');

  var NotificationsSettingList = SettingsLiat?.filter(f => f.moduleId === '0a6c6b89-1d52-4eaa-8d2c-002c74b1f6e0');

  var PayrollSettingList = SettingsLiat?.filter(f => f.moduleId === '0a6c6b89-1d52-4eaa-8d2c-011c74b1f6e0');

  var AttendanceSettingList = SettingsLiat?.filter(f => f.moduleId === '0a6c6b89-1d52-4eaa-8d2c-012c74b1f6e0');

  var FixedAssetSettingList = SettingsLiat?.filter(f => f.moduleId === '0a6c6b89-1d52-4eaa-8d2c-051c74b1f6e0');

  var PayablesSettingList = SettingsLiat?.filter(f => f.moduleId === '0a6c6b89-1d52-4eaa-8d2c-052c74b1f6e0');

  var ReceivablesSettingList = SettingsLiat?.filter(f => f.moduleId === '0a6c6b89-1d52-4eaa-8d2c-053c74b1f6e0');

  var InventorySettingList = SettingsLiat?.filter(f => f.moduleId === '0a6c6b89-1d52-4eaa-8d2c-070c74b1f6e0');

  var SalesSettingList = SettingsLiat?.filter(f => f.moduleId === '0a6c6b89-1d52-4eaa-8d2c-080c74b1f6e0');

  var PosSettingList = SettingsLiat?.filter(f => f.moduleId === '0a6c6b89-1d52-4eaa-8d2c-081c74b1f6e0');

  return {
    SettingsLiat,
    HRSettingList,
    AMESettingList,
    FLEETSettingList,
    SUSettingList,
    FinanceSettingList,
    NTXSettingList,
    PosSettingList,
    SalesSettingList,
    InventorySettingList,
    ReceivablesSettingList,
    PayablesSettingList,
    FixedAssetSettingList,
    AttendanceSettingList,
    PayrollSettingList,
    NotificationsSettingList,
    ReportsSettingList,
    loading,
    error
  };
};

export default useGetNtxSettings;
